import { useState, useRef } from 'react';
import { getTranscription } from '../../axios/API';
import { classNames } from '../../utils/classNames';

import { BsSquareFill } from 'react-icons/bs';
import { ReactComponent as VoiceIcon } from '../../assets/input/voice-icon.svg';
import '../../styles/pulse.scss';

const VoiceRequest = ({ scrollToBottom, handleSubmit, formLoading, recordingLoading, setRecordingLoading }) => {
	const [isRecording, setIsRecording] = useState(false);
	const [mediaRecorder, setMediaRecorder] = useState(null);
	const recordingTimeout = useRef(null);

	const window_navigator = window.navigator;

	const handleRecordingStart = async () => {
		try {
			const stream = await window_navigator.mediaDevices.getUserMedia({ audio: true });
			const recorder = new MediaRecorder(stream);
			const audioChunks = [];

			recorder.ondataavailable = (event) => {
				audioChunks.push(event.data);
			};

			recorder.onstop = async () => {
				clearTimeout(recordingTimeout.current);
				stream.getTracks().forEach((track) => track.stop());

				const audioBlob = new Blob(audioChunks, { type: 'audio/mp4' });
				const formData = new FormData();
				formData.append('file', audioBlob, 'audio.mp4');

				setRecordingLoading(true);

				try {
					scrollToBottom();
					const { data } = await getTranscription(formData);
					handleSubmit({ preventDefault: () => {} }, data.transcription);
				} catch (error) {
					console.error(error);
				} finally {
					setRecordingLoading(false);
					setIsRecording(false);
				}
			};

			recorder.start();
			setMediaRecorder(recorder);
			setIsRecording(true);

			recordingTimeout.current = setTimeout(() => {
				if (recorder.state === 'recording') recorder.stop();
			}, 10000);
		} catch (error) {
			console.error('Error accessing microphone:', error);
		}
	};

	const handleRecordingStop = (event) => {
		event.preventDefault();

		if (mediaRecorder) {
			clearTimeout(recordingTimeout.current);
			mediaRecorder.stop();
		}
	};

	return isRecording && !recordingLoading ? (
		<button
			onClick={handleRecordingStop}
			aria-label='Stop recording'
			className={classNames(
				'h-8 md:h-11 w-8 md:w-11 aspect-square',
				'flex items-center justify-center',
				'rounded-full bg-[#2597DC] shadow-voiceShadow',
				'pulsate-border recording z-20'
			)}
		>
			<div className='pulse' />
			<BsSquareFill color='white' />
		</button>
	) : (
		<button
			type='submit'
			aria-label='Start recording'
			onClick={handleRecordingStart}
			disabled={formLoading}
			className={classNames(
				'h-8 md:h-11 w-8 md:w-11 aspect-square bg-[#2597DC]',
				'flex items-center justify-center rounded-full',
				'shadow-voiceShadow z-20'
			)}
		>
			<VoiceIcon className='w-[10px] h-[12px] md:w-[20px] md:h-[20px] text-white' />
		</button>
	);
};

export default VoiceRequest;
